<template>
  <section class="optimal-dosing">
    <b-container>
      <b-row>
        <b-col>
          <div class="contents mx-auto text-center">
            <h2 class="mb-0">
              What is the optimal dosing for JORNAY PM?<br class="d-none d-lg-block" />
              A doctor can work with you to find the right dose.
            </h2>

            <img src="@/assets/images/3_25/how/pills.svg"
              title="5 pill graphics showcasing the 5 dose options from 20 mg to 100 mg."
              alt="5 pill graphics showcasing the 5 dose options from 20 mg to 100 mg." />

            <p class="pb-4 text-black fw-semibold">
              The recommended starting dose is 20 mg, and your healthcare provider may slowly increase the dose in order
              to reach an effective level. In clinical studies, most patients 6 to 12 years of age had optimal efficacy
              at 60 mg or 80 mg. The maximum dose is 100 mg. A daily dose above 100&nbsp;mg has not been studied.
            </p>

            <p class="pb-4 text-black fw-semibold">
              Work with your healthcare provider to find the best time to take JORNAY PM in the evening.
            </p>

            <p class="text-black fw-semibold">
              Remember to always follow your healthcare provider’s treatment plan. JORNAY PM should be taken exactly as
              prescribed.
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "OptimalDosing",
};
</script>
